import { GestorBloqueio } from './../../../../../models/gestor-bloqueio';
import {
    Component,
    OnInit,
    ViewContainerRef,
    HostListener
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { CedenteGestor } from 'src/app/models/cedentegestor';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GestorService } from 'src/app/services/gestor.service';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import * as removeAccents from 'remove-accents';
import { environment } from 'src/environments/environment';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { PerfilService } from 'src/app/services/perfil.service';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { OpcoesGestorPaginado } from 'src/app/models/opcoes-gestor-paginado';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CedenteService } from 'src/app/services/cedente.service';

@Component({
    selector: 'app-gestor-list',
    templateUrl: './gestor-list.component.html',
    styleUrls: ['./gestor-list.component.css']
})
export class GestorListComponent implements OnInit {
    public currentUser: Auth;
    public cedenteGestor: CedenteGestor[];
    public cedenteGestorTemp: CedenteGestor;
    public cedenteGestorList: CedenteGestor[];

    // Filtro
    public filtroNome: string;
    public filtroCPF: string;
    public filtroStatus: string;

    // Paginação
    currentPage = 1;
    showItem = '10';
    totalItems: number;
    search: string;

    // Ordenação
    public sortOrder: boolean;

    // modal delete
    public blockCount: number;
    public selectAll: boolean;
    public cedenteGestorToDelete: CedenteGestor;
    public cedenteGestorToBlock: CedenteGestor;
    public cedenteGestorToUnblock: CedenteGestor;
    public showContextMenu = true;

    // apenas gestor responsavel
    public apenasGestorResponsavel = false;
    public gestoresCadastradosLabel = 'Gestores Cadastrados';
    public gestorLabel = 'Gestor';
    public gestoresLabel = 'Gestores';

    public permitirBuscarCPF = true;
    public permitirBuscarNome = true;
    public permitirBuscarStatus = true;
    public permitirBuscarCPFLike = true;
    public permitirBuscarNomeLike = true;

    public isMobile = false;
    public inSenhaInvalid = false;
    public inSenhaInvalidMessage = '';

    public telefoneGestor: string;

    constructor(
        private authenticationService: AuthenticationService,
        private gestorService: GestorService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef,
        private parametrosDataService: ParametrosDataService,
        private perfilService: PerfilService,
        private cedenteService: CedenteService,
    ) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.loadList();
        this.loadViewConfig();
    }

    loadViewConfig() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        const perfis = this.perfilService.currentPerfisValue;

        this.showContextMenu = true;

        if (parametros) {
            if (parametros[ParametrosKey.apenasGestorResponsavelGerenciarGestores]) {
                this.apenasGestorResponsavel = BooleanConverter.getBoolean(parametros[ParametrosKey.apenasGestorResponsavelGerenciarGestores]);

                if (this.apenasGestorResponsavel) {
                    this.apenasGestorResponsavel = perfis.some(
                        x => x.nomeNormalizado === PerfilNormalizado.Responsavel
                    );
                }
            } else {
                this.apenasGestorResponsavel = false;
            }

            if (
                parametros[ParametrosKey.labelPersonalizadaGestoresCadastrados]
            ) {
                this.gestoresCadastradosLabel =
                    parametros[
                    ParametrosKey.labelPersonalizadaGestoresCadastrados
                    ];
            }

            if (parametros[ParametrosKey.labelPersonalizadaGestor]) {
                this.gestorLabel =
                    parametros[ParametrosKey.labelPersonalizadaGestor];
            }

            if (parametros[ParametrosKey.labelPersonalizadaGestores]) {
                this.gestoresLabel =
                    parametros[ParametrosKey.labelPersonalizadaGestores];
            }

            if (parametros[ParametrosKey.permitirMenuContexto]) {
                this.showContextMenu = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirMenuContexto]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaCPFGestores]) {
                this.permitirBuscarCPF = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaCPFGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaNomeGestores]) {
                this.permitirBuscarNome = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaNomeGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaStatusGestores]) {
                this.permitirBuscarStatus = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaStatusGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaCPFIncrementalGestores]) {
                this.permitirBuscarCPFLike = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaCPFIncrementalGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaNomeIncrementalGestores]) {
                this.permitirBuscarNomeLike = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaNomeIncrementalGestores]
                );
            }
        }
    }

    getOptions(): OpcoesGestorPaginado {

        return new OpcoesGestorPaginado(
            (this.currentPage - 1) * +this.showItem,
            +this.showItem,
            this.filtroCPF,
            this.filtroNome,
            this.filtroStatus,
            this.search,
            this.permitirBuscarNome,
            this.permitirBuscarNomeLike,
            this.permitirBuscarCPF,
            this.permitirBuscarCPFLike,
            this.permitirBuscarStatus
        );
    }

    loadGestores() {
        const options = this.getOptions();

        this.gestorService.GetAllPaginated(this.currentUser.token.assignorGuid, options).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.cedenteGestor = response.result.gestores;
                    this.cedenteGestorList = response.result.gestores;
                    this.totalItems = response.result.total;
                    for (const c of this.cedenteGestorList) {
                        if (c.bloqueado) {
                            c.statusGestor = 'Bloqueado';
                        } else {
                            c.statusGestor = 'Desbloqueado';
                        }

                        const tam =
                            environment.TOTAL_CARACTERE_CPF -
                            c.gestor.pessoa.documento.toString().length;
                        let str = c.gestor.pessoa.documento.toString();
                        for (let i = 0; i < tam; i++) {
                            str = '0' + str;
                        }
                        c.gestor.pessoa.documento = str;
                    }
                    this.cedenteGestorList = this.cedenteGestorList.sort(
                        (a, b) =>
                            a.gestor.pessoa.pessoaFisica.pessoaNome.localeCompare(
                                b.gestor.pessoa.pessoaFisica.pessoaNome
                            )
                    );
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao buscar as informações!');
            }
        );
    }

    private loadList() {
        this.loadGestores();
    }

    create() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    invite() {
        this.router.navigate(['invite'], { relativeTo: this.route.parent });
    }

    goToListAccepted() {
        this.router.navigate(['list-accepted'], { relativeTo: this.route.parent });
    }

    edit(cendenteGestor: CedenteGestor) {
        this.router.navigate([`edit/${cendenteGestor.gestor.gestorGuid}`], {
            relativeTo: this.route.parent
        });
    }

    showItemChanged(event) {
        this.showItem = event;
        this.loadGestores();
    }

    changePage($event) {
        this.currentPage = $event;
        this.loadGestores();
    }


    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    searchFilter(word: string) {
        this.search = word;
        this.loadGestores();
    }

    applyFilter(nome: string, cpf: string, status: string) {
        this.filtroNome = nome;
        this.filtroCPF = cpf;
        this.filtroStatus = status;
        this.loadGestores();
    }


    orderNome(item: any[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.gestor.pessoa.pessoaFisica.pessoaNome
                .toString()
                .localeCompare(
                    b.gestor.pessoa.pessoaFisica.pessoaNome.toString(),
                    undefined,
                    { numeric: true }
                );
            if (sortOrder) {
                result = b.gestor.pessoa.pessoaFisica.pessoaNome
                    .toString()
                    .localeCompare(
                        a.gestor.pessoa.pessoaFisica.pessoaNome.toString(),
                        undefined,
                        { numeric: true }
                    );
            }
            return result;
        });
    }

    orderCPF(item: any[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.gestor.pessoa.documento
                .toString()
                .localeCompare(
                    b.gestor.pessoa.documento.toString(),
                    undefined,
                    { numeric: true }
                );
            if (sortOrder) {
                result = b.gestor.pessoa.documento
                    .toString()
                    .localeCompare(
                        a.gestor.pessoa.documento.toString(),
                        undefined,
                        { numeric: true }
                    );
            }
            return result;
        });
    }

    orderStatus(item: any[], sortOrder: boolean) {
        this.cedenteGestorList.sort((a, b) => {
            let result = a.statusGestor
                .toString()
                .localeCompare(b.statusGestor.toString(), undefined, {
                    numeric: true
                });
            if (sortOrder) {
                result = b.statusGestor
                    .toString()
                    .localeCompare(a.statusGestor.toString(), undefined, {
                        numeric: true
                    });
            }
            return result;
        });
    }

    realodList() {
        let tempList = this.cedenteGestor;
        if (this.filtroNome) {
            tempList = tempList.filter(s =>
                removeAccents(s.gestor.pessoa.pessoaFisica.pessoaNome)
                    .toLowerCase()
                    .includes(removeAccents(this.filtroNome).toLowerCase())
            );
        }

        if (this.filtroCPF) {
            tempList = tempList.filter(s =>
                s.gestor.pessoa.documento
                    .toString()
                    .toLowerCase()
                    .includes(
                        removeAccents(
                            this.filtroCPF
                                .toLocaleLowerCase()
                                .replace(/\D+/g, '')
                                .replace(' ', '')
                        )
                    )
            );
        }

        if (this.filtroStatus) {
            tempList = tempList.filter(s =>
                removeAccents(s.statusGestor)
                    .toLowerCase()
                    .includes(removeAccents(this.filtroStatus).toLowerCase())
            );
        }

        this.cedenteGestorList = tempList;
    }

    showDelete(content: any, cendenteGestor: CedenteGestor) {
        this.cedenteGestorToDelete = cendenteGestor;
        this.OpenModal(content);
    }

    showBlock(content: any, cendenteGestor: CedenteGestor) {
        this.cedenteGestorToBlock = cendenteGestor;
        this.OpenModal(content);
    }

    showUnblock(content: any, cendenteGestor: CedenteGestor) {
        this.cedenteGestorToUnblock = cendenteGestor;
        this.OpenModal(content);
    }

    chagePhone(content: any, cedenteGestor: CedenteGestor) {
        this.cedenteGestorTemp = cedenteGestor;

        this.cedenteService.pinChagePhone(this.cedenteGestorTemp.gestor.gestorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.gestorService
                        .getGestor(this.cedenteGestorTemp.gestor.gestorGuid, this.currentUser.token.assignorGuid)
                        .subscribe(
                            response => {
                                if (response.status === ApiError.Sucesso) {
                                    if (response.result.telefone != null){
                                        let phone = (response.result.telefone.ddd + '' + response.result.telefone.numero)
                                        this.telefoneGestor = this.format(phone, phone.length==11 ? '(##) #####-####' : '(##) ####-####');
                                    } else {
                                        this.telefoneGestor = null
                                    }
                                }
                            },
                        );
                    this.OpenModal(content);
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao solicitar pin!');
            }
        );
    }

    editPhone(codigo: number, telefone: string) {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');

        this.cedenteService.editPhone(this.cedenteGestorTemp.gestor.gestorGuid, telefone, codigo).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success("Telefone editado com sucesso!");
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Ocorreu um erro ao editar telefone!');
            }
        );
    }


    OpenModal(content: any) {
        if (this.isMobile) {
            this.modalService.open(content, { centered: true, size: 'sm' });
        } else {
            this.modalService.open(content, { centered: true, size: 'lg' });
        }
    }

    delete(cedenteGestor: CedenteGestor) {
        this.gestorService
            .delete(
                this.currentUser.token.assignorGuid,
                cedenteGestor.gestor.gestorGuid
            )
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message);
                        this.loadList();
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        `'Ocorreu um erro ao excluir o gestor:' ${cedenteGestor.gestor.pessoa.pessoaFisica.pessoaNome}`
                    );
                }
            );
    }

    bloquear(cedenteGestor: CedenteGestor, senha: string) {

        this.inSenhaInvalid = false;
        this.inSenhaInvalidMessage = '';

        if (!senha) {
            this.inSenhaInvalidMessage = 'Preencha a senha';
            this.inSenhaInvalid = true;
        } else {
            const gestorBloqueio = new GestorBloqueio();
            gestorBloqueio.Senha = senha;
            gestorBloqueio.CedenteGuid = this.currentUser.token.assignorGuid;
            gestorBloqueio.GestorGuid = cedenteGestor.gestor.gestorGuid;
            gestorBloqueio.GestorLogadoGuid = this.currentUser.token.userReferenceId;

            this.gestorService
                .bloquear(gestorBloqueio)
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message);
                            this.modalService.dismissAll();
                            // this.loadList();
                            const cedenteGestorUpdate = this.cedenteGestorList.find(x => x === cedenteGestor);
                            cedenteGestorUpdate.bloqueado = true;
                            cedenteGestorUpdate.statusGestor = 'Bloqueado';
                            //const index = this.cedenteGestorList.indexOf(cedenteGestorUpdate);
                            //this.cedenteGestorList[index] = cedenteGestorUpdate;

                        } else {
                            this.alertService.error(response.message);
                            this.inSenhaInvalidMessage = response.message;
                            this.inSenhaInvalid = true;
                        }
                    },
                    error => {
                        this.alertService.error(
                            'Ocorreu um erro ao bloquerar o gestor'
                        );
                    }
                );
        }
    }

    desbloquear(cedenteGestor: CedenteGestor, senha: string) {
        this.inSenhaInvalid = false;
        this.inSenhaInvalidMessage = '';

        if (!senha) {
            this.inSenhaInvalidMessage = 'Preencha a senha';
            this.inSenhaInvalid = true;
        } else {
            const gestorBloqueio = new GestorBloqueio();
            gestorBloqueio.Senha = senha;
            gestorBloqueio.CedenteGuid = this.currentUser.token.assignorGuid;
            gestorBloqueio.GestorGuid = cedenteGestor.gestor.gestorGuid;
            gestorBloqueio.GestorLogadoGuid = this.currentUser.token.userReferenceId;

            this.gestorService
                .desbloquear(gestorBloqueio)
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message);
                            this.modalService.dismissAll();
                            // this.loadList();

                            const cedenteGestorUpdate = this.cedenteGestorList.find(x => x === cedenteGestor);
                            cedenteGestorUpdate.bloqueado = false;
                            cedenteGestorUpdate.statusGestor = 'Desbloqueado';
                            //const index = this.cedenteGestorList.indexOf(cedenteGestorUpdate);
                            //this.cedenteGestorList[index] = cedenteGestorUpdate;
                        } else {
                            this.alertService.error(response.message);
                            this.inSenhaInvalidMessage = response.message;
                            this.inSenhaInvalid = true;
                        }


                    },
                    error => {
                        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                    }
                );
        }
    }

    updateBlockCount() {
        this.blockCount = this.cedenteGestor.filter(x => x.toBlock).length;
    }

    selectAllToDelete(value: boolean) {
        this.cedenteGestor.forEach(obj => {
            obj.toBlock = value;
        });
        this.updateBlockCount();
    }

    showDeleteAll(content: any) {
        this.updateBlockCount();
        this.modalService.open(content, { centered: true, size: 'sm' });
    }

    deleteAllSelected() {
        this.cedenteGestor.forEach(obj => {
            if (obj.toBlock) {
                this.delete(obj);
            }
        });
        this.updateBlockCount();
    }

    //#endregion

    isResponsavel(item: CedenteGestor): boolean {
        return item.perfisGestor.find(x => x.perfilNomeNormalizado === PerfilNormalizado.Responsavel) != null;
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 10) {
            return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        } else if (telefone.length > 10) {
            return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
    }

    format(value, pattern) {
      var i = 0,
          v = value.toString();
      return pattern.replace(/#/g, _ => v[i++]);
    }
}
